import { documentHasElements } from "modules/dom";

documentHasElements(".js-global-career-purpose", () => {

    const careerPurpose = {
        init: function () {
            careerPurpose.addSmoothScroll();
        },
        addSmoothScroll: () => {
            const html = document.querySelector("html");
            
            if (html) {
                html.classList.add("html-scroll__smooth");
            }
        },
    };

    careerPurpose.init();

});